import React from "react";
import "./card-rates-home.scss";
//import Slider from "react-slick";
//import "slick-carousel/slick/slick.css";
//import "slick-carousel/slick/slick-theme.css";
//import useSettingCarousel from "../../../hooks/carousel";
import CardRatesDescriptionHome from "../../atoms/card-rates-description-home/card-rates-description-home";
interface ShareCardInterface {
  datas: any;
}
const CardPayHome = (props: ShareCardInterface) => {
  const { datas } = props;

  return (
    <div>
      <div className="m-share-modal-home__container__center">
        <div className="m-share-modal-home__container__cardbody hide-on-mobile">
          {datas[0].referenciaPlantillaContenido.map((value, key) => {
            return (
              <div key={"desk" + key}>
                {value.imagenPrincipal ? (
                  <>
                    <CardRatesDescriptionHome datas={value} />
                  </>
                ) : (
                  <></>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
export default CardPayHome;
